import styled from 'styled-components';

const Badge = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({backgroundColor = '#ff4444'}) => backgroundColor};
`;

export default Badge;


// WEBPACK FOOTER //
// ./src/components/Badge/Badge.js